import { actions } from '..';
import * as api from '../../api';
import * as legacy from '../../legacy';
import { ContactType, EntityType } from '../../model';
import { getConfig, selectMyAccess, selectConfigProp } from '../reducers/config';
import { selectDirectoryView } from '../reducers/localSettings';
import { all, SagaContext } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';
import { IsIpfxMobilityClientHost, ExposeApiToMobilityClientHost } from '../../mobility-client-api';
import { isBrowser } from "react-device-detect";
import { fetchCrmSettings } from '../../api/dynamics365api';
import { updateTelephoneControllerStatus } from '../../Electron/telephone-controller';

export async function fetchConfig(ctx: SagaContext) {
  try {

    const cfg = await api.getConfig()
    const crmConfig = await fetchCrmSettings()
    legacy.setConfig(cfg.original)

    ctx.dispatch(actions.setConfig(cfg.config))
    ctx.dispatch(actions.setCrmSettings(crmConfig))
    // needs data from the config so needs to happen here
    ctx.dispatch(actions.fetchFavQueues.request())
    ctx.dispatch(actions.fetchMyQueues.request())
    ctx.dispatch(actions.fetchGosLimits.request())
    ctx.dispatch(actions.fetchMyQueueEmails.request())
    ctx.dispatch(actions.fetchQueueEmails.request())

    //reset for licencsing 
    const store = ctx.getState()
    const mediaQueueTwitter = selectConfigProp(store, 'mediaQueueTwitter')
    const mediaQueueFacebook = selectConfigProp(store, 'mediaQueueFacebook')
    const mediaQueueEmail = selectConfigProp(store, 'mediaQueueEmail')
    const mediaQueueWebChat = selectConfigProp(store, 'mediaQueueWebChat')

    ctx.dispatch(actions.resetSearchFilter({ CALL: true, VM: true, EMAIL: mediaQueueEmail, FB: mediaQueueFacebook, TWEET: mediaQueueTwitter, TC: mediaQueueWebChat, EMAILAUTO: false, EMAILATTACHMENTS: false, DIRECTIONIN: true }))
  } catch (e) {
    ctx.dispatch(actions.redirectToLogin())
  }
}

export async function fetchUnreadVoiceMailCount(ctx: SagaContext) {
  ctx.dispatch(actions.fetchUnreadVoiceMailCount())
}

export async function fetchFolderIds(ctx: SagaContext) {
  try {
    const ids = await api.getFavouriteFolderIds()

    ctx.dispatch(actions.setAdditionalConfig({ favouriteQueuesFolderId: ids.queue }))
    ctx.dispatch(actions.setAdditionalConfig({ favouriteExtensionFolderId: ids.extension }))
    ctx.dispatch(actions.setAdditionalConfig({ favouriteContactFolderId: ids.contact }))
    ctx.dispatch(actions.setAdditionalConfig({ shortcutFolderId: ids.shortcut }))

    ctx.dispatch(actions.fetchFavContactsRequeust(ids.contact))
  } catch (e) {
    ctx.dispatch(actions.redirectToLogin())
  }
}

const init = takeEvery(actions.init, async ctx => {

  const mobility = process.env.NODE_ENV === 'development' && !isBrowser ? true : IsIpfxMobilityClientHost()
  ctx.dispatch(actions.setInIpfxMobilityElectron(mobility))
  ExposeApiToMobilityClientHost(ctx)  // can get gated by IsMobilityClientHost, but we don't for ease of testing.

  const handlers = [
    fetchConfig,
    fetchUnreadVoiceMailCount,
    fetchFolderIds,
  ]

  try {
    await all(...handlers)(ctx)
    updateTelephoneControllerStatus(true)
  } catch (e) {
    ctx.dispatch(actions.redirectToLogin())
  }

  ctx.dispatch(actions.setInIpfxElectron(window.ipcRenderer !== undefined))
  ctx.dispatch(actions.clearSelectedNumber())

  const store = ctx.getState()
  const access = selectMyAccess(store)
  const config = getConfig(store)
  const view = selectDirectoryView(store)

  //change the default director view to contacts if no access to extension and have access to contacts
  if (config && view.entityType === EntityType.Extension && !access.features.toolbarDirectory) {
    if ((access.features.companyContactsAccess || access.features.directoryCompanyContactAdd || access.features.directoryPersonalContactAdd)) {
      if (access.features.directoryPersonalContactAdd) {
        ctx.dispatch(actions.setDirectoryView({ regionId: config.regionId, entityType: EntityType.Contact, contactType: ContactType.Personal }))
      } else if (access.features.companyContactsAccess || access.features.directoryCompanyContactAdd) {
        ctx.dispatch(actions.setDirectoryView({ regionId: config.regionId, entityType: EntityType.Contact, contactType: ContactType.Company }))
      } else {
        ctx.dispatch(actions.setDirectoryView({ regionId: config.regionId, entityType: EntityType.Contact, contactType: ContactType.Customer }))
      }
    }
  }
})

const shutdown = takeEvery(actions.shutdown, async ctx => {
  updateTelephoneControllerStatus(false)
})

export default all(
  init,
  shutdown,
)
